{
    "required": "Bitte füllen Sie dieses Feld aus.",
    "required_short": "Bitte ausfüllen.",
    "email": "Bitte geben Sie eine gültige Email-Adresse an.",
    "phone": "Bitte geben Sie eine gültige Mobiltelefonnummer an. Format: +49 12345678912",
    "iban": "Diese IBAN ist ungültig.",
    "bic": "Das Format der BIC ist ungültig",
    "account_number": "Diese Kontonummer ist ungültig.",
    "sort_code": "Diese Bankleitzahl ist ungültig.",
    "vat": "Das Format der Steuernummer ist ungültig",
    "name": "Bitte geben Sie einen gültigen Namen ein.",
    "url": "Ungültige URL (z. B. http://finway.de)",
    "number": "Bitte geben Sie eine gültige Nummer ein.",
    "not_zero": "Darf nicht 0 sein.",
    "integer": "Bitte geben Sie eine gültige Zahl ein.",
    "string": "Bitte geben Sie gültigen Text ein.",
    "string_too_long": "Eingabe ist zu lang.",
    "string_too_short": "Eingabe ist zu kurz.",
    "string_white_space_start_or_end": "Bitte entfernen Sie Leerzeichen am Anfang und Ende.",
    "string_white_space": "Bitte entfernen Sie Leerzeichen.",
    "string_white_space_duplicate": "Bitte entfernen Sie dopplte Leerzeichen.",
    "alternative_budget_period": "Bitte geben Sie einen alternativen Zeitraum ein",
    "unique": "{{value}} muss eindeutig sein.",
    "duplicate": "{{value}} Duplikat.",
    "cannot_be_in_past": "Datum kann nicht in der Vergangenheit sein.",
    "cannot_be_in_future": "Datum kann nicht in der Zukunft sein.",
    "numeric_min_max": "Muss zwischen {{min}} und {{max}} liegen.",
    "only_letters": "Nur Buchstaben und Leerzeichen erlaubt (keine Umlaute oder Sonderzeichen).",
    "only_letters_including_umlauts": "Nur Buchstaben und Leerzeichen erlaubt (keine Sonderzeichen).",
    "invalid_characters": "Ungültige Zeichen.",
    "beneficiary_name_characters": {
        "sepa": "Enthält Zeichen, die die Bank nicht akzeptiert. Bitte nur Buchstaben, Ziffern, Leerzeichen und . , ' - / ? : ( ) + & verwenden.",
        "faster_payments": "Enthält Zeichen, die die Bank nicht akzeptiert. Bitte nur Buchstaben ohne Akzente oder Umlaute, Ziffern, Leerzeichen und . , ’ - / ? : ( ) + # = ! \" % & * < > ; { @ verwenden. Als Apostroph bitte ’ statt ' verwenden."
    },
    "between": {
        "number": {
            "exclusive_min_inclusive_max": "Muss größer {{min}} und kleiner gleich {{max}} sein."
        }
    },
    "out_of_range": {
        "date": "Das Datum liegt außerhalb des erlaubten Zeitraums."
    },
    "min": {
        "string": "Bitte geben Sie mindestens {{min}} Zeichen ein.",
        "number": "Nur Zahlen >= {{min}} sind erlaubt.",
        "number_negative": "Nur Zahlen < {{min}} sind erlaubt.",
        "number_short": "Muss >= {{min}} sein.",
        "number_very_short": "Min: {{min}}"
    },
    "greater": {
        "string": "Bitte geben Sie mehr als {{min}} Zeichen ein.",
        "number": "Nur Zahlen > {{min}} sind erlaubt.",
        "number_short": "Muss > {{min}} sein."
    },
    "exact": {
        "string": "Muss genau {{num}} Zeichen lang sein."
    },
    "max": {
        "string": "Nur maximal {{max}} Zeichen erlaubt.",
        "number": "Max: {{max}}"
    },
    "below": {
        "string": "Bitte geben Sie weniger als {{max}} Zeichen ein.",
        "number": "Nur Zahlen < {{max}} sind erlaubt.",
        "number_short": "Muss < {{max}} sein."
    },
    "date_after": "{{attribute}} vor {{compare}}.",
    "date_before": "{{attribute}} nach {{compare}}.",
    "bigger_amount": "{{attribute}} kann nicht größer als der {{compare}} sein.",
    "smaller_amount": "{{attribute}} kann nicht kleiner als der {{compare}} sein.",
    "password": {
        "notmatching": "Die eingegebenen Passwörter stimmen nicht überein.",
        "disallowed_word": "Das Passwort enthält unerlaubte Wortlaute.",
        "password_has_leading_or_trailing_spaces": "Das Passwort darf nicht mit Leerzeichen beginnen oder enden.",
        "password_must_have_at_least_one_special_symbol": "Das Passwort muss mindestens ein Sonderzeichen enthalten (!, @, #, $, %, etc)."
    },
    "rejection_note": "Bitte geben Sie einen Grund an.",
    "invoice_needed": "Es muss mindestens eine Rechnung hochgeladen sein.",
    "stripe_payment": {
        "invalid_fields": "Bitte geben Sie alle Felder ein.",
        "invalid_card": "Diese Kartennummer ist ungültig.",
        "missing_card_info": "Bitte füllen Sie die Karteninformationen aus."
    },
    "extended_alphanumeric": "Keine Sonderzeichen.",
    "limit_approver": "Approver muss ein Admin oder Approver des gleichen Teams sein.",
    "numeric": "Nur Zahlen sind erlaubt.",
    "no_leading_zero": "Keine führende Null erlaubt.",
    "subject_contains_unsupported_character": "Betreff enthält nicht unterstützte Zeichen",
    "date_in_the_future": "Datum in der Zukunft.",
    "no_empty_comment": "Bitte geben Sie einen Kommentar ein.",
    "date_birthday": "Das Alter ist ungültig, Sie müssen mindestens 18 Jahre alt sein",
    "date_of_birth_missing": "Bitte geben Sie Ihr Geburtsdatum ein.",
    "date_of_birth_in_future": "Das Geburtsdatum muss in der Vergangenheit liegen.",
    "taxId": "Die Steuer-ID sollte mindestens 8 Zeichen haben",
    "shares_percentage": "Der prozentuale Anteil am Unternehmen sollte zwischen 0 und 100 liegen.",
    "shares_percentage_value": "Alle Unternehmensanteile von den Geschäftsführern und den Gesellschaftern sollten 100% nicht überschreiten.",
    "only_uppercase": "Nur Großbuchstaben erlaubt.",
    "accept_terms": "Bitte stimmen Sie den Vertagsbedingungen und den AGBs zu.",
    "start_date": "Startdatum",
    "end_date": "Enddatum",
    "bu_code": "BU Nummer",
    "account_code": "Code",
    "account_name": "Name",
    "date_range_max_months": "Zeitraum muss innerhalb von {{max}} Monaten liegen.",
    "date_range_max_quarters": "Der ausgewählte Zeitraum muss innerhalb von {{max}} Quartalen liegen.",
    "date_range_max_years": "Zeitraum muss innerhalb von {{max}} Jahren liegen.",
    "duplicate_approver": "Eine Workflow-Regel kann keine doppelten Genehmiger:innen haben.",
    "duplicate_limit_approver": "Es kann keine doppelten Genehmiger:innen geben.",
    "duplicate_approval_limit": "Es kann kein doppeltes Limit geben.",
    "bu_code_validation": "Inkompatibel zu DATEV.",
    "expense_account_code_validation": "Inkompatibel zu DATEV.",
    "card_limit_change_reason": "Bitte geben Sie einen Grund für die Limitänderung an.",
    "auto_approver_not_allowed_for_conditions": "Auto Approver für konditionelle Regeln nicht erlaubt.",
    "approver_cannot_be_the_requester": "Genehmiger:in kann nicht Antragsteller:in sein.",
    "responsible_employee_only_with_trigger_type_cost_center": "Die Option \"Verantwortliche:r Benutzer:in\" kann nur mit dem Auslösetyp \"Kostenstelle\" ausgewählt werden.",
    "subscription": {
        "started_on_later_than_renewal_date": "Leistungsdatum kann nicht gleich oder nach dem Vertragsverlängersungsdatum sein.",
        "renewal_date_earlier_than_started_on": "Vertragsverlängerungsdatum kann nicht gleich oder vor dem Leistungsdatum sein."
    },
    "per_diem": {
        "invalid_input": "Ungültige Dateneingabe im Antrag:",
        "end_date_less_than_last_transfer_date": "Rückkehr- vor Weiterreisedatum",
        "end_date_less_than_transfer_date": "Rückkehr- vor Weiterreisedatum",
        "end_time_date_than_start_date": "Rückkehr- vor Startdatum",
        "start_date_more_than_end_date": "Startdatum nach Rückkehr-/Weiterreisedatum",
        "end_time_less_than_last_transfer_time": "Rückkehr- vor Weiterreisezeit",
        "end_time_less_than_transfer_time": "Rückkehr- vor Weiterreisezeit",
        "end_time_less_than_start_time": "Rückkehr- vor Startzeit",
        "start_time_more_than_end_time": "Startzeit nach Rückkehr-/Weiterreisezeit",
        "destinations_invalid": "Fehlende(r) Zielort(e)",
        "destination_dates_invalid": "Fehlende Datumsangabe(n)",
        "months_maximum": "Ihre Reise hat den {{months}}-Monats-Zeitraum überschritten. Wenden Sie sich bitte an Ihr Finanzteam, da die reguläre Verpflegungspauschale in diesem Fall nicht erstattet wird.",
        "invalid_table": "Die Rückerstattungs-tabelle muss neu erstellt werden.",
        "hoursMinimum_one": "Sie haben keinen Anspruch auf Rückerstattung, weil die Dauer Ihrer Geschäftsreise weniger als {{count}} Stunde beträgt.",
        "hoursMinimum_other": "Sie haben keinen Anspruch auf Rückerstattung, weil die Dauer Ihrer Geschäftsreise weniger als {{count}} Stunden beträgt."
    },
    "mileage": {
        "must_provide_reason": "Der Grund für den zusätzlichen Abstand ist erforderlich."
    },
    "csv_settings_headers_empty": "Sie müssen zumindest ein Feld auswählen.",
    "csv_settings_name_unique": "Der Name ist bereits in Verwendung.",
    "number_interval": "Bitte geben Sie eine gültige Zahl zwischen {{min}} und {{max}} ein.",
    "export_status_not_supported": "Das Exportformat ist für den hier gewählten Status nicht verfügbar.",
    "no_whitespace_only": "Das Feld darf nicht nur aus Leerzeichen bestehen.",
    "demote_fallback_approver": "Diese:r Benutzer:in ist derzeit als Ersatz-Genehmiger:in dieses Unternehmens eingerichtet und kann daher nicht herabgestuft werden.",
    "user_deleted": "Benutzer:in wurde gelöscht.",
    "must_be_positive": "Muss positiv sein",
    "required_mileage_stops": "Bitte füllen Sie dieses Feld mit einem Vorschlag aus.",
    "sso_domain_can_not_be_an_email": "Die SSO-Domain darf keine Email Adresse sein",
    "period_too_long": "Der Zeitraum darf nicht länger als {{max}} Monate sein.",
    "personio": {
        "tabs_one": "Fehler im {{tab}}-Tab.",
        "tabs_other": "Fehler in den Tabs {{tab}}.",
        "duplicate_email_one": "Die Email {{email}} ist bereits in der Ausschlussliste.",
        "duplicate_email_other": "Die Emails {{email}} sind bereits in der Ausschlussliste."
    },

    "invalid_address_format": "Ungültiges Adressformat.",
    "number_exceeding_decimal_places": "Bitte geben Sie eine gültige Zahl mit maximal {{decimal_places}} Dezimalstellen ein.",
    "work_phone_deletion_not_allowed": "Telefonnummer kann wegen Teilnahme am Kartenprogramm nicht entfernt werden."
}
